import { Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { TEXT_COLORS } from '@/common/presentation/constants/colors';
import tid from '@/common/infrastructure/config/tid';

/**
 * LLAMS-465 — shown in place of CRM whenever CanAccessCrm denies access (LaunchDarkly
 * rollout flag off, no CrmLicense, or LD identity not trusted). This is a UX-only
 * denial: CRMAPI (LLAMS-464) remains the authoritative enforcement boundary regardless
 * of whether this screen is ever reached.
 */
export const CrmUnavailable: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '2rem',
        boxSizing: 'border-box'
      }}
    >
      <h1 style={{ fontSize: '24px', color: TEXT_COLORS.TEXT_PRIMARY, margin: 0 }}>CRM isn&apos;t available for your account.</h1>
      <p style={{ textAlign: 'center', marginTop: '1.5em', maxWidth: '600px', color: TEXT_COLORS.TEXT_SECONDARY }}>
        Your organization may not have CRM enabled yet, or your account may not have a CRM license. Contact your administrator if you
        believe this is unexpected.
      </p>

      <div style={{ marginTop: '2rem', display: 'flex', gap: '1rem' }}>
        <Button onClick={() => (window.location.href = '/')} variant="contained" {...tid('crm:unavailable:go-to-homepage-button')}>
          <ArrowForwardIcon style={{ marginRight: '0.2rem' }} />
          GO TO HOMEPAGE
        </Button>
      </div>
    </div>
  );
};
